import { CookieOptionsExtended } from '../../types/ssr';
import { QueryCookieParamOptions } from './query-cookie-param.interface';

export const getQueryParamByLocation: (location: Location, paramName: string) => string | null = (
  location: Location,
  paramName: string
): string | null => {
  const searchParams: URLSearchParams = new URLSearchParams(location.search ?? '');
  const value: string | null = (searchParams.get(paramName) ?? '').trim() || null;

  return value;
};

export const resolveOptionalParamFromText: (paramText: string | null | undefined) => string | null = (
  paramText: string | null | undefined
): string | null => {
  const normalizedText: string = (paramText ?? '').trim();

  if (!normalizedText) {
    return null;
  }

  return normalizedText;
};

export const getRootCookieDomain: (hostname: string) => string = (hostname: string): string => {
  return hostname.split('.').slice(-2).join('.');
};

export const resolveQueryCookieParam: (options: QueryCookieParamOptions) => string | null = (
  options: QueryCookieParamOptions
): string | null => {
  const { location, cookieFacade, queryParam, cookieName, hostname }: QueryCookieParamOptions = options;

  const queryText: string | null = getQueryParamByLocation(location, queryParam);
  const cookieText: string = cookieFacade.get(cookieName);
  const value: string | null = resolveOptionalParamFromText(queryText || cookieText);

  if (value) {
    const cookieOptions: CookieOptionsExtended = {
      path: '/',
      domain: getRootCookieDomain(hostname),
    };
    cookieFacade.set(cookieName, value, cookieOptions);
  }

  return value;
};
